import React from 'react';
import { TCountOfItems } from 'types';
import { Pagination } from 'antd';
import Text from 'components/Text/Text';
import style from './PaginationComponentNew.module.scss';

interface IProps {
	currentPage: number;
	countOfItems: TCountOfItems;
	entitiesCount: number;
	changeCurrentPage: (value: number) => void;
}

export const PaginationComponentNew: React.FC<IProps> = React.memo(
	({ currentPage, countOfItems, entitiesCount, changeCurrentPage }) => {
		const from = (currentPage - 1) * Number(countOfItems) + 1;
		const to = currentPage * Number(countOfItems);
		const total = entitiesCount;

		return (
			<div className={style.container} data-test="PaginationComponentNew">
				<Text
					className={style.counter}
					translationNameSpace="listing"
					translationKey="paginationLabel"
					translationOptions={{
						from,
						to: to < total ? to : total,
						total,
					}}
					size="xs"
				/>
				<Pagination
					className={style.pagination}
					current={currentPage}
					pageSize={Number(countOfItems)}
					total={entitiesCount}
					onChange={changeCurrentPage}
					showSizeChanger={false}
				/>
			</div>
		);
	},
);
